import { Outlet, useOutletContext } from "react-router-dom";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { NotificationBell } from "@/components/NotificationBell";
import { ReactNode, useState, useCallback } from "react";

type HeaderExtras = ReactNode | null;
type LayoutContext = { setHeaderExtras: (extras: HeaderExtras) => void };

export function useLayoutHeader() {
  return useOutletContext<LayoutContext>();
}

export function AuthenticatedLayout() {
  const [headerExtras, setHeaderExtras] = useState<HeaderExtras>(null);

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <header className="h-10 flex items-center border-b border-border/50 bg-background px-3 shrink-0 sticky top-0 z-40 gap-2">
            <SidebarTrigger className="text-muted-foreground hover:text-foreground shrink-0" />
            {headerExtras && <div className="flex items-center gap-2 min-w-0 flex-1">{headerExtras}</div>}
            <div className="flex items-center gap-2 ml-auto shrink-0">
              <NotificationBell />
            </div>
          </header>
          <main className="flex-1 overflow-auto">
            <Outlet context={{ setHeaderExtras }} />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
